import React, { useEffect, useState } from 'react'

import { useDispatch } from "react-redux"
import { getFilterList } from "../../features/customer/customerSlice"
import { ClickAwayListener } from "@mui/base"

const FiltersListModal = ({
  fetchFilters,
  isOpenFilterList,
  setIsOpenFilterList,
  clickOnButton,
  setClickOnButton,
  setIsOpenFilters,
  flow,
  filterListId = null,
  setFilterListId = null,
}) => {
  const dispatch = useDispatch()
  const [filtersList, setFiltersList] = useState([])
  const getFiltersList = async () => {
    try {
      const response = await dispatch(getFilterList({ flow }))
      setFiltersList(response?.payload?.data)
    } catch (error) {
      console.error('An unexpected error occurred:', error)
    }
  }

  useEffect(() => {
    getFiltersList()
  }, [isOpenFilterList])

  const handleClickAway = () => {
    if (clickOnButton) {
      setClickOnButton(false)
    } else {
      setIsOpenFilterList(false)
    }
  }

  useEffect(() => {
    if (clickOnButton) {
      setIsOpenFilterList(true)
      setClickOnButton(false)
    }
    setIsOpenFilters(false)
  }, [isOpenFilterList])

  const fetchByFiltersList = async (id) => {
    // Update URL with selected filter ID
    if (setFilterListId) {
      setFilterListId(id)
    }
    fetchFilters(id)
    setIsOpenFilters(false)
    setIsOpenFilterList(false)
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={`fixed rounded-2xl p-6 min-w-[450px] max-h-[450px]  w-max bg-paper mb-[65px] z-[9999] shadow-custom`}>
        <div className="border border-divider border-x-0 border-t-0 text-lg pb-2.5 text-text-secondary">
          Saved Filters
        </div>
        <div className="py-2 w-full flex flex-col items-start">
          {filtersList?.map((val) =>
            <button
              key={val?._id}
              className={`py-3 px-4 w-full text-start ${
                filterListId === val?._id
                  ? 'bg-primary-main/20 font-semibold'
                  : 'hover:bg-primary-main/10'
              }`}
              onClick={() => fetchByFiltersList(val?._id)}
            >
              {val?.label}
            </button>
          )}
        </div>
      </div>
    </ClickAwayListener>
  )
}

export default FiltersListModal
